import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link, withRouter} from 'react-router-dom';
import moment from 'moment-timezone';
import {CUSTOMER_INQUIRY_CATEGORIES} from '../../../actions/customerInquiry.actions';
import {GAME_TYPES, getPublicGameTitle} from '../../../constants/gameType.constants';
import TextEditor from '../../Common/TextEditor';
import queryString from 'query-string';
import {Button, ButtonGroup, Table} from '../../Common/PageComponents';
import './inquiry.scss';

const stateToProps = state => {
  return {
    userName: state.user.username,
  };
};

class CustomerInquiryEditor extends Component {
  _extractPreselectedCategoryIfExists() {
    let requestParams = queryString.parse(window.location.search);
    if (
      !requestParams.selectedCategory ||
      !Object.keys(CUSTOMER_INQUIRY_CATEGORIES).includes(requestParams.selectedCategory)
    ) {
      return '';
    }
    return requestParams.selectedCategory;
  }

  _submitInquiry(e) {
    e.preventDefault();
    let inquiry = new FormData();
    inquiry.append('username', this.props.userName);
    inquiry.append('category', this.category.value);
    inquiry.append('gameType', this.gameType.value);
    inquiry.append('title', this.title.value);
    inquiry.append('content', this.textEditor.state.content.toString('html'));
    inquiry.append('file', this.file.files[0]);
    if (!this._validateNecessaryInputs()) {
      return;
    }

    let headers = {
      Authorization: sessionStorage.getItem('token'),
    };

    let skipMaintenance = localStorage.getItem('skipMaintenance');
    if (skipMaintenance) {
      headers['SkipMaintenance'] = skipMaintenance;
    }

    fetch(`${API_URL}/inquiries`, {
      method: 'POST',
      headers: headers,
      body: inquiry,
    }).then(response => this._handleSubmissionResult(response));
  }

  _validateNecessaryInputs() {
    let contentText = this._extractTextFromElement(this.textEditor.state.content.toString('html'));
    if (!this.category.value) {
      alert('카테고리를 선택해주세요');
      this.category.focus();
      return false;
    } else if (!this.title.value.trim()) {
      alert('제목을 입력해주세요');
      this.title.focus();
      return false;
    } else if (!contentText.trim()) {
      alert('내용을 입력해주세요');
      return false;
    } else {
      return true;
    }
  }

  _extractTextFromElement(htmlString) {
    let element = document.createElement('div');
    element.innerHTML = htmlString.trim();
    let contentText = element.innerText;
    return contentText;
  }

  _handleSubmissionResult(response) {
    if (response.status === 201) {
      alert('작성하신 1:1 문의가 제출되었습니다.');
      this.props.history.push('/customer/inquiries');
    } else {
      alert('1:1 문의 제출에 실패했습니다.');
    }
  }

  render() {
    let currentDate = moment().format('YYYY-MM-DD');
    let userName = this.props.userName;
    return (
      <div id="inquiryEditor">
        <form method="post" name="w_form" encType="multipart/form-data">
          <Table theme={'form'}>
            <colgroup>
              <col width={140} />
              <col width="*" />
            </colgroup>
            <tbody>
              <tr>
                <th>아이디</th>
                <td ref={node => (this.username = node)}>{userName}</td>
              </tr>
              <tr>
                <th>상담일</th>
                <td>{currentDate}</td>
              </tr>
              <tr>
                <th>상담내역</th>
                <td>
                  <select
                    name="category"
                    ref={node => (this.category = node)}
                    defaultValue={this._extractPreselectedCategoryIfExists()}
                    style={{marginRight: '10px'}}
                  >
                    <option value="">항목 선택</option>
                    {Object.entries(CUSTOMER_INQUIRY_CATEGORIES).map(category => (
                      <option key={category[0]} value={category[0]}>
                        {category[1]}
                      </option>
                    ))}
                  </select>
                  <select
                    name="gameType"
                    ref={node => (this.gameType = node)}
                    defaultValue=""
                    style={{marginRight: '10px'}}
                  >
                    <option value="">게임 선택</option>
                    <option value="">해당 없음</option>
                    {GAME_TYPES.map(gameType => (
                      <option key={gameType} value={gameType}>
                        {getPublicGameTitle(gameType)}
                      </option>
                    ))}
                  </select>
                  <span>알맞은 항목을 선택하셔야 빠른 처리가 이루어 집니다.</span>
                </td>
              </tr>
              <tr>
                <th>제목</th>
                <td>
                  <input
                    className="input_text"
                    type="text"
                    name="title"
                    id="title"
                    maxLength={80}
                    style={{width: 454}}
                    ref={node => (this.title = node)}
                  />
                </td>
              </tr>
              <tr>
                <th>내용</th>
                <td>
                  <TextEditor ref={textEditor => (this.textEditor = textEditor)} />
                </td>
              </tr>
              <tr>
                <th>첨부파일</th>
                <td>
                  <input
                    type="file"
                    className="input_text"
                    maxLength={255}
                    name="file"
                    style={{width: 446}}
                    ref={node => (this.file = node)}
                  />
                </td>
              </tr>
            </tbody>
          </Table>
        </form>
        <ButtonGroup>
          <Button onClick={e => this._submitInquiry(e)}>상담하기</Button>
          <Link to="/customer/inquiries">
            <Button theme={'gray'}>취소</Button>
          </Link>
        </ButtonGroup>
      </div>
    );
  }
}

export default withRouter(connect(stateToProps)(CustomerInquiryEditor));
